// AUTO-GENERATED at build time by scripts/generateBuildInfo.js. Do not edit.
export const APP_VERSION = "cd8fd65";
export const BUILD_DATE = "20 Sept 2026, 11:32 am";
